import * as React from 'react';

function SvgCloseIcon(props) {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect width={32} height={32} rx={6} fill="#F5F5F7" />
      <path
        opacity={0.4}
        d="M11.148 18.911a.915.915 0 000 1.294l.647.647a.915.915 0 001.294 0L16 17.941 14.06 16l-2.912 2.911zm9.704-7.116l-.647-.647a.915.915 0 00-1.294 0l-2.91 2.911L17.94 16l2.911-2.911a.915.915 0 000-1.294z"
        fill="#748CAD"
      />
      <path
        d="M20.852 18.911a.915.915 0 010 1.294l-.647.647a.915.915 0 01-1.294 0l-7.763-7.763a.916.916 0 010-1.294l.647-.647a.915.915 0 011.294 0l7.763 7.763z"
        fill="#748CAD"
      />
      <path
        d="M17.941 16l2.911-2.911a.915.915 0 000-1.294l-.647-.647a.915.915 0 00-1.294 0l-2.91 2.911-2.912-2.911a.915.915 0 00-1.294 0l-.647.647a.915.915 0 000 1.294L14.06 16l-2.91 2.911a.915.915 0 000 1.294l.646.647a.915.915 0 001.294 0L16 17.941l2.911 2.911a.915.915 0 001.294 0l.647-.647a.915.915 0 000-1.294L17.942 16z"
        fill="#748CAD"
      />
    </svg>
  );
}

export default SvgCloseIcon;
